import { BrowserRouter as Router, Routes, Route, useLocation } from "react-router-dom";
import Header from "./components/Header";
import Footer from "./components/Footer";
import PageDetail from "./components/PageDetail";
import Home from "./pages/Home";
import ServiceDetails from "./components/ServiceDetails";
import LoginPage from "./components/LoginPage";
import LandingPage from "./components/LandingPage";
import JananiChat from "./components/JananiChat";
import { AuthProvider } from "./components/AuthContext";
import IncomeTaxPassword from "./components/IncomeTaxPassword";
import AttendanceSheet from "./components/AttendanceSheet";
import GstPassword from "./components/GstPassword";
import GstSummary from "./components/GstSummary";
import IncomeTaxFilingStatus from "./components/IncomeTaxFilingStatus";
import StaffManagement from "./components/StaffManagement";
import GstFilingStatus from "./components/GstFilingStatus";
import BuildYourWebsite from "./pages/BuildYourWebsite";
import Builder from "./pages/Builder";

function AppContent() {
  const location = useLocation();
  const isBuilderPage = location.pathname.startsWith('/builder');

  return (
    <>
      {!isBuilderPage && <Header />}
      <main className="content">
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/pages/:slug" element={<PageDetail />} />
          <Route path="/services/:slug" element={<ServiceDetails />} />
          <Route path="/login" element={<LoginPage />} />
          <Route path="/landing" element={<LandingPage />} />
          <Route path="/janani-chat" element={<JananiChat />} />
          <Route path="/income-tax-password" element={<IncomeTaxPassword />} />
          <Route path="/attendance-sheet" element={<AttendanceSheet />} />
          <Route path="/gst-password" element={<GstPassword />} />
          <Route path="/gst-summary" element={<GstSummary />} />
          <Route path="/income-tax-filingstatus" element={<IncomeTaxFilingStatus />} />
          <Route path="/staff-management" element={<StaffManagement />} />
          <Route path="/gst-filingstatus" element={<GstFilingStatus />} />
          <Route path="/build-your-website" element={<BuildYourWebsite />} />
          <Route path="/builder/:id" element={<Builder />} />
        </Routes>
      </main>
      {!isBuilderPage && <Footer />}
    </>
  );
}

function App() {
  return (
    <AuthProvider>
      <Router>
        <AppContent />
      </Router>
    </AuthProvider>
  );
}

export default App;